import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RowTool from "@/pages/RowTool";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RowTool />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
